var TorsoView = require('backbone-torso/modules/View');
var patientWalletInsuranceListItemTemplate = require('./patientWalletInsuranceListItemTemplate.hbs');

/**
 * View for displaying a wallet insurance list item
 *
 * @class PatientWalletInsuranceListItemView
 * @constructor
 */
module.exports = TorsoView.extend({
  template: patientWalletInsuranceListItemTemplate,
  tagName: 'li',
  className: 'index__item index__item--wallet',

  /**
   * Handles clicks on delete link
   * @events
   */
  events: {
    'click [data-delete-wallet-insurance]': '_deleteWalletInsurance'
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function(options) {
    this.model.setPatientVecnaId(options.context.patientVecnaId);
    this._clearDeleteFailures();
    this.listenTo(this.viewState, 'change:errors', this.render);
  },

  /**
   * Clear any failures logged by previous attempts to create.
   *
   * @method _clearCreateFailures
   * @private
   */
  _clearDeleteFailures: function() {
    this.set('errors', {
      deleteInsuranceFailed: false
    });
  },

  /**
   * @method _deleteWalletInsurance
   * @param event {Event} of click
   * @private
   */
  _deleteWalletInsurance: function(event) {
    if (event) {
      event.preventDefault();
    }

    this.model.set('savedToWallet', false);
    this.model.save()
      .fail(function() {
        this.set('errors', {
          deleteInsuranceFailed: true
        });
      }.bind(this));
  }
});
